import script from "./Airplane.vue?vue&type=script&setup=true&lang=js"
export * from "./Airplane.vue?vue&type=script&setup=true&lang=js"

import "./Airplane.vue?vue&type=style&index=0&id=906ea0d8&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-906ea0d8"]])

export default __exports__